export default __webpack_public_path__ + "static/media/glitch11.37eb5ad2.png";